import { useEffect, useState, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";
import { useToken } from "@/app/services/context/TokenContext";

interface OAuthHandlerProps {
  children: ReactNode;
}

export default function OAuthHandler({ children }: OAuthHandlerProps) {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setToken } = useToken();

  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    if (code) {
      handleAuthRedirect(code);
    }
  }, []);

  const handleAuthRedirect = async (code: string) => {
    const grantType = "authorization_code";
    try {
      setIsSubmitting(true);
      // const response = await gxLoginTokenApi({ code, grantType });

      // if (response?.status !== 1) {
      //   setIsSubmitting(false);
      //   return;
      // }

      // const { accessToken } = response.data;
      // sessionStorage.setItem("auth", accessToken);
      // setToken(accessToken);

      // const pathWithoutCode = window.location.pathname;
      // window.history.replaceState({}, document.title, pathWithoutCode);
      // navigate(pathWithoutCode, { replace: true });
    } catch (error) {
      console.error("OAuthHandler error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitting) {
    return (
      <div className="bg-cover bg-[#121464] w-screen h-screen flex items-center justify-center">
        <SubmitLoading />
      </div>
    );
  }

  return <>{children}</>;
}
